import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = [
  {
    label: 'Home',
    icon: 'HomeIcon',
    href: 'https://farm.circacoin.io/',
  },
  // {
  //   label: 'Trade',
  //   icon: 'TradeIcon',
  //   initialOpenState: true,
  //   items: [
  //     {
  //       label: 'Exchange',
  //       href: '/swap',
  //     },
  //     {
  //       label: 'Liquidity',
  //       href: '/pool',
  //     },
  //   ],
  // },
  {
    label: 'Exchange',
    icon: 'TradeIcon',
    href:'/swap'
  },
  {
    label: 'Liquidity',
    icon: 'LiquidityIcon',
    href:'/pool'
  },
  {
    label: 'Earn CCC',
    icon: 'FarmIcon',
    href: 'https://farm.circacoin.io/farms',
  },
  // {
  //   label: 'Pools',
  //   icon: 'PoolIcon',
  //   href: 'https://stake.circacoin.io/pools',
  // },
    {
    label: 'Referrals',
    icon: 'GroupsIcon',
    href: 'https://farm.circacoin.io/referrals',
  },
  {
    label: 'Charts',
    icon: 'InfoIcon',
    href: 'https://farm.circacoin.io/charts',
  },
  // {
  //   label: 'Lottery',
  //   icon: 'TicketIcon',
  //   href: 'https://oex.finance/lottery',
  // },
  // {
  //   label: 'NFT',
  //   icon: 'NftIcon',
  //   href: 'https://oex.finance/nft',
  // },
  // {
  //   label: 'Teams & Profile',
  //   icon: 'GroupsIcon',
  //   calloutClass: 'rainbow',
  //   items: [
  //     {
  //       label: 'Leaderboard',
  //       href: 'https://oex.finance/teams',
  //     },
  //     {
  //       label: 'Task Center',
  //       href: 'https://oex.finance/profile/tasks',
  //     },
  //     {
  //       label: 'Your Profile',
  //       href: 'https://oex.finance/profile',
  //     },
  //   ],
  // },
  // {
  //   label: 'Info',
  //   icon: 'InfoIcon',
  //   items: [
  //     {
  //       label: 'Overview',
  //       href: 'https://pancakeswap.info',
  //     },
  //     {
  //       label: 'Tokens',
  //       href: 'https://pancakeswap.info/tokens',
  //     },
  //     {
  //       label: 'Pairs',
  //       href: 'https://pancakeswap.info/pairs',
  //     },
  //     {
  //       label: 'Accounts',
  //       href: 'https://pancakeswap.info/accounts',
  //     },
  //   ],
  // },
  // {
  //   label: 'IFO',
  //   icon: 'IfoIcon',
  //   href: 'https://oex.finance/ifo',
  // },
  // {
  //   label: 'More',
  //   icon: 'MoreIcon',
  //   items: [
  //     {
  //       label: 'Voting',
  //       href: 'https://voting.oex.finance',
  //     },
  //     {
  //       label: 'Github',
  //       href: 'https://github.com/pancakeswap',
  //     },
  //     {
  //       label: 'Docs',
  //       href: 'https://docs.oex.finance',
  //     },
  //     {
  //       label: 'Blog',
  //       href: 'https://pancakeswap.medium.com',
  //     },
  //   ],
  // },
    {
    label: 'Leaderboard',
    icon: 'LeaderBoardIcon',
    href: 'https://farm.cccoins.io/table',
  },
      {
    label: 'FAQ',
    icon: 'FAQIcon',
    href: 'https://farm.cccoins.io/faq',
  },
  // {
  //   label: 'More',
  //   icon: 'MoreIcon',
  //   items: [
  //     {
  //       label: 'Leaderboard',
  //       href: 'https://stake.cccoins.io/table',
  //     },
  //   ],
  // },
]

export default config
